module.exports = __webpack_public_path__ + "img/demo_1.18ac2bd3.png";